import * as React from 'react';
import { AbstractSharingLink } from './AbstractSharingLink';

export class LinkedIn extends AbstractSharingLink {
    public render() {
        const titleAttribute = this.context.i18n.translate('Auf LinkedIn teilen');
        const model = this.props.model;
        const localUrl = encodeURIComponent(this.buildSharingUri(model));
        const title = encodeURIComponent(model.title);
        const uri = `https://www.linkedin.com/shareArticle?`
            + `mini=true&`
            + `url=${localUrl}&`
            + `title=${title}`;

        return <div className="jc-share-link -linkedin">
            <a href={uri} target="_blank" rel="noopener noreferrer" title={titleAttribute}>
                <i className="fab fa-linkedin-in"/>
            </a>
        </div>;
    }
}
